import { render, staticRenderFns } from "./EditProgramPemilikSistem.vue?vue&type=template&id=32038be6&"
import script from "./EditProgramPemilikSistem.vue?vue&type=script&lang=js&"
export * from "./EditProgramPemilikSistem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports